import React, { useEffect, useState } from 'react';
import { Backdrop, Box } from '@mui/material';
import { Root, classes } from './utils';
import AddNewMembersSASide from './AddNewMembersSASide';
import AgGrid from '../../common-components/common-ag-grid/AgGrid';
import { globalClasses } from '../../utils/globalUtils';
import { getGridFilterSortStatus } from '../../../../services/allInvoiceApi';
import superManagerColumnDef from './superManagerColumnDef';
import superManager from '../../../../services/superManager';
import AddSalesAdminAndSalesCredit from './AddSalesAdminAndSalesCredit';

const SuperManager = () => {
  const [open, setOpen] = useState(false);
  const [invitationEmail, setInvitationEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [roleError, setRoleError] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const [gridSettingData, setGridSettingData] = useState({});
  const [selectedExpiration, setSelectedExpiration] = useState({
    title: '2 Days',
    time: '2d',
  });
  const [openAddCredit, setOpenAddCredit] = useState(false);
  const [refreshGrid, setRefreshGrid] = useState(false);
  const handleExpireTimeValue = (newValue) => {
    setSelectedExpiration(newValue);
  };
  const handleClose = () => {
    setInvitationEmail('');
    setEmailError('');
    setRoleError(null);
    setSelectedRole(null);
    setOpen(false);
    setSelectedExpiration({
      title: '2 Days',
      time: '2d',
    });
  };
  const getFilterSortData = async () => {
    try {
      const response = await getGridFilterSortStatus('super-manager');
      setGridSettingData(response);
    } catch (err) {
      return err;
    }
  };

  useEffect(() => {
    getFilterSortData();
  }, []);
  return (
    <Root className={classes.root}>
      <Box className={classes.mainBox}>
        <Box className={classes.titleMainBox}>
          <Backdrop className={globalClasses.backdrop} open={open}>
            <AddNewMembersSASide
              handleClose={handleClose}
              invitationEmail={invitationEmail}
              setInvitationEmail={setInvitationEmail}
              roleError={roleError}
              setRoleError={setRoleError}
              emailError={emailError}
              setEmailError={setEmailError}
              selectedExpiration={selectedExpiration}
              selectedRole={selectedRole}
              setSelectedRole={setSelectedRole}
              handleExpireTimeValue={handleExpireTimeValue}
            />
          </Backdrop>
          {openAddCredit && (
            <Backdrop className={globalClasses.backdrop} open={openAddCredit}>
              <AddSalesAdminAndSalesCredit
                setOpen={setOpenAddCredit}
                setRefreshGrid={setRefreshGrid}
              />
            </Backdrop>
          )}
        </Box>
        <AgGrid
          TitleHeader="My Team"
          className={classes.subscriberOverviewAgGridStyle}
          columnData={superManagerColumnDef}
          getRowData={superManager}
          gridSettingData={gridSettingData}
          gridKey="super-manager"
          setOpen={setOpen}
          setOpenAddCredit={setOpenAddCredit}
          refreshGrid={refreshGrid}
          setGridSettingData={setGridSettingData}
        />
      </Box>
    </Root>
  );
};

export default SuperManager;
